export class Tenant {
  companyName?: string
  logoUrl?: string
}
